// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-email-js": () => import("./../src/pages/email.js" /* webpackChunkName: "component---src-pages-email-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-telefono-js": () => import("./../src/pages/telefono.js" /* webpackChunkName: "component---src-pages-telefono-js" */)
}

